import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { NavMarker } from 'react-rhumb';
import { useCollectionQuery } from '../hooks/useCollectionQuery';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { NoResults } from './NoResults';
import { ResultsGridWithSummary } from './ResultsGridWithSummary';
import { ResultsGridWithoutSummary } from './ResultsGridWithoutSummary';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGrid() {
  const {
    loading,
    data,
    error
  } = useSearchResultsQuery();
  return /*#__PURE__*/_jsx(SearchResultsNavMarker, {
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "800"
    }) : error ? /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    }) : (data === null || data === void 0 ? void 0 : data.result.cards.length) === 0 ? /*#__PURE__*/_jsx(NoResults, {}) : data !== null && data !== void 0 && data.result.aiAnswer ? /*#__PURE__*/_jsx(ResultsGridWithSummary, {}) : /*#__PURE__*/_jsx(ResultsGridWithoutSummary, {})
  });
}
function SearchResultsNavMarker({
  children
}) {
  const isCollection = !!useCollectionQuery().data;
  return isCollection ? /*#__PURE__*/_jsx(NavMarker, {
    name: "COLLECTION_LOAD",
    children: children
  }) : /*#__PURE__*/_jsx(NavMarker, {
    name: "SEARCH_RESULTS_LOAD",
    children: children
  });
}